import {bindActionCreators} from 'redux';
import {createSelector} from 'reselect';

const makeLocalStateSelector = (namespace) =>
  createSelector(
    (state) => state[namespace],
    (localState) => localState || {}
  );

class Controller {
  constructor({namespace, reducers = [], actionCreators, mapStateToProps, autoDisconnect}) {
    if (!namespace) {
      throw new Error('controller missing namespace');
    }
    this.namespace = namespace;
    this.actionCreators = actionCreators;
    this.reducers = {};
    this.getLocalState = makeLocalStateSelector(namespace);
    this.autoDisconnect = !!autoDisconnect;

    reducers.forEach((reducer) => {
      /* istanbul ignore else */
      if (typeof reducer === 'string') {
        if (reducer === '*') {
          throw ' "*" reducer requires handler';
        }
        this.addReducer(reducer);
      } else if (typeof reducer === 'object') {
        this.addReducer(reducer.action, reducer.handler);
      }
    });

    this.mapStateToProps = mapStateToProps ? mapStateToProps.bind(this) : null;
  }

  mapDispatchToProps = (dispatch) => {
    return bindActionCreators({...this.actionCreators}, dispatch);
  };

  addReducer(action, reducer) {
    this.reducers[action] = reducer || this.setLocalState.bind(this);

    return this.reducers;
  }

  addResetReducer(actions = []) {
    if (typeof actions === 'string') {
      actions = [actions];
    }
    actions.forEach((action) => this.addReducer(action, this.resetState.bind(this)));
  }

  /**
   * Default reducer for actions
   * store action data into local store
   */
  setLocalState(state, action) {
    const data = {...action};
    delete data.type;
    data.__reset__ = undefined;
    const localState = this.getLocalState(state);
    const ret = {};
    ret[this.namespace] = {...localState, ...data};

    return ret;
  }

  resetState() {
    const ret = {};
    ret[this.namespace] = {__reset__: true};

    return ret;
  }

  static create(config) {
    if (config instanceof Controller) {
      return config;
    }

    return new Controller(config);
  }

  getExports() {
    return {
      autoDisconnect: this.autoDisconnect,
      reducers: this.reducers,
      mapDispatchToProps: this.mapDispatchToProps,
      mapStateToProps: this.mapStateToProps,
    };
  }
}

export default Controller;
